import React from "react";
import PropTypes from "prop-types";
import queryString from "query-string";
import styled from "styled-components";

import { StyledSocialLink } from "./styles";
import { contentTypes } from "core/props";

let ShareImageToSocialMedia = ({
    className,
    children,
    creatorName,
    platform,
    imageType,
    permalinkPath
}) => {
    const getShareUrl = () => {
        const imagePermalink = `https://${location.host}${permalinkPath}`;

        let shareUrl = "";
        let shareUrlQueryParams = "";

        const shareText = `Love this ${
            imageType === "icon" ? "icon" : "photo"
        } ${creatorName ? `by ${creatorName} ` : ``}from @NounProject.`;

        if (platform === "Twitter") {
            shareUrl = "https://twitter.com/intent/tweet";

            shareUrlQueryParams = {
                text: shareText,
                url: imagePermalink
            };
        } else if (platform === "Facebook") {
            shareUrl = "https://www.facebook.com/sharer/sharer.php";

            shareUrlQueryParams = {
                u: imagePermalink
            };
        }

        const shareUrlQueryParamsStringified = queryString.stringify(
            shareUrlQueryParams
        );

        return `${shareUrl}/?${shareUrlQueryParamsStringified}`;
    };

    const openWindowToShare = ({ shareUrl }) => {
        const width = 575;
        const height = 400;
        const left = (window.innerWidth - width) / 2;
        const top = (window.innerHeight - height) / 2;

        const windowOptions = `status=1,width=${width},height=${height},left=${left},top=${top}`;

        return window.open(shareUrl, "", windowOptions);
    };

    const handleClick = e => {
        e.preventDefault();

        const shareUrl = getShareUrl();
        openWindowToShare({ shareUrl });
    };

    return (
        <StyledSocialLink className={className} onClick={handleClick}>
            {children}
        </StyledSocialLink>
    );
};

ShareImageToSocialMedia.propTypes = {
    className: PropTypes.string,
    platform: PropTypes.oneOf(["Twitter", "Facebook"]).isRequired,
    imageType: PropTypes.oneOf(contentTypes).isRequired,
    creatorName: PropTypes.string.isRequired,
    permalinkPath: PropTypes.string.isRequired
};

ShareImageToSocialMedia = styled(ShareImageToSocialMedia)``;

export default ShareImageToSocialMedia;
